/* @flow */
/** @jsx h */
import { h, VNode } from 'preact';
import cssStyle from './index.css';
import { hexToRGBA } from '../../js/colors';

type PropTypes = {
  id?: string;
  children: VNode;
  onClick: (e: MouseEvent) => void;
  onTouchStart: (e: TouchEvent) => void;
  backgroundColor?: string;
  backgroundOpacity?: number;
  labelColor?: string;
  labelOpacity?: number;
  fontSize?: number;
  style: h.JSX.CSSProperties;
  isInterstitialAdUnit: boolean;
};

export default function Control({
  id,
  children,
  onClick = () => {},
  onTouchStart = () => {},
  backgroundColor = '#28323c',
  backgroundOpacity = 0.5,
  labelColor = '#FFFFFF',
  labelOpacity = 1,
  fontSize = 16,
  style = {},
  isInterstitialAdUnit = true
}: PropTypes) {
  const containerStyle = {
    background: isInterstitialAdUnit
      ? hexToRGBA(backgroundColor, backgroundOpacity)
      : '',
    color: hexToRGBA(labelColor, labelOpacity),
    fill: hexToRGBA(labelColor, labelOpacity),
    fontSize,
    pointerEvents: 'auto',
    ...style
  };

  return (
    <div
      id={id}
      onTouchStart={onTouchStart}
      onClick={onClick}
      style={containerStyle as any}
      className={
        isInterstitialAdUnit ? cssStyle.container : cssStyle.thumbnailContainer
      }
    >
      {children}
    </div>
  );
}
